var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgI = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 2,
  height: 9,
  viewBox: "0 0 2 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.210449 3.08643H1.77881V9H0.210449V3.08643ZM0.994629 2.44189C0.761882 2.44189 0.563151 2.36312 0.398438 2.20557C0.233724 2.04801 0.151367 1.85286 0.151367 1.62012C0.151367 1.38737 0.233724 1.19222 0.398438 1.03467C0.563151 0.880697 0.761882 0.803711 0.994629 0.803711C1.23096 0.803711 1.43148 0.880697 1.59619 1.03467C1.7609 1.19222 1.84326 1.38737 1.84326 1.62012C1.84326 1.85286 1.7609 2.04801 1.59619 2.20557C1.43148 2.36312 1.23096 2.44189 0.994629 2.44189Z",
  fill: "white"
})));
export { SvgI as ReactComponent };
export default __webpack_public_path__ + "assets/icons/i.3774fd.svg";